export default __webpack_public_path__ + "static/media/remainder-history-icon.8c66ead9.svg";